import { Box } from "@chakra-ui/react";
import { Spacing } from "goi_common";
import { ParlorDetailProps } from "@/types/parlor";
import { Dispatch, SetStateAction } from "react";
import SelectedReviews from "@/components/common/SelectedReviews";
import PrepaidBanners from "@/components/common/PrepaidBanners";
import PriceInfoTabPanelMayVersion from "@/containers/Parlor/ParlorDetailContainer/components/TabInfoSection/PriceInfoTabPanel/PriceInfoTabPanelMayVersion";
import AmenityInfoTabPanelMayVersion from "@/containers/Parlor/ParlorDetailContainer/components/TabInfoSection/AmenityInfoTabPanel/AmenityInfoTabPanelMayVersion";
import ParlorRequestBoxMayVersion from "@/containers/Parlor/ParlorDetailContainer/components/ParlorRequestBox/ParlorRequestBoxMayVersion";
import MubinsoQuickCard from "@/containers/Parlor/ParlorRegionContainer/components/MubinsoQuickCard";
import { ABEnabledContainer } from "@/components/ABEnabledContainer";
import { isPriceDisclosureParlor } from "@/utils/parlorPriceDisclosure";
import ParlorPriceDisclosureSection from "@/containers/Parlor/ParlorDetailContainer/components/ParlorPriceDisclosureSection";

function TabInfoSectionVersion({
  parlor,
  selectedSangjo,
  setSelectedSangjo,
  discountDescription,
  closestParlors,
  nearbyFacilities,
  isExcluded,
}: {
  parlor: ParlorDetailProps;
  selectedSangjo: string;
  setSelectedSangjo: Dispatch<SetStateAction<string>>;
  discountDescription?: string;
  closestParlors: any;
  nearbyFacilities?: any;
  isExcluded?: boolean;
}) {
  return (
    <>
      <PriceInfoTabPanelMayVersion
        isExcluded={isExcluded}
        expectedCharges={parlor.expected_charge_sum}
        binsos={parlor.binsos}
        services={parlor.services}
        parlor={parlor}
        selectedSangjo={selectedSangjo}
        setSelectedSangjo={setSelectedSangjo}
        discountDescription={discountDescription}
        closestParlors={closestParlors}
      />

      <Box width="100%" alignItems="center">
        <Box width="100%" maxWidth="480px" padding="12px" margin="auto">
          <ParlorRequestBoxMayVersion
            sido={parlor.sido}
            sigungu={parlor.sigungu}
            companyName={parlor.companyname}
          />
        </Box>
      </Box>

      {/* 무빈소 빠른확인 카드 (상세, #320 A/B). A=미노출 / B=노출. 기존 빠른폼 뒤 배치 */}
      <Box width="100%" alignItems="center">
        <Box width="100%" maxWidth="480px" padding="12px" margin="auto">
          <ABEnabledContainer
            experimentKey={320}
            ComponentA={<></>}
            ComponentB={
              <MubinsoQuickCard
                variant="hero"
                purpose="mubinso"
                heroBadge="무빈소"
                heroTitle={
                  <>
                    {parlor.companyname},
                    <br />
                    무빈소로도 가능할까요?
                  </>
                }
                heroDescription="빈소 없이 간소하게 모시는 방법과 예상 비용을 확인해보세요."
                defaultSido={parlor.sido != null ? Number(parlor.sido) : null}
                defaultSigungu={parlor.sigungu != null ? Number(parlor.sigungu) : null}
                hideRegion
                loginEventFrom="parlor_detail"
                parlorName={parlor.companyname}
                submitText="무빈소 가능 여부 확인하기"
                eventConfig={{
                  path: "parlor_detail",
                  sidoTrigger: "mbn_card-sido",
                  sigunguTrigger: "mbn_card-sgg",
                  statusTrigger: "mbn_card-status",
                  submitTrigger: "mbn_card-submit",
                }}
                memo={`${parlor.companyname} 페이지에서 바로 제출한 고객이며 무빈소 니즈가 있을 수 있습니다.`}
              />
            }
          />
        </Box>
      </Box>

      {/* 견적 폼과 #320 카드 뒤, 지도 바로 위. 일반 템플릿과 같은 자리 */}
      {isPriceDisclosureParlor(parlor) && (
        <Box width="100%" maxWidth="480px" margin="auto">
          <ParlorPriceDisclosureSection parlor={parlor} />
        </Box>
      )}

      <AmenityInfoTabPanelMayVersion
        parlor={parlor}
        closestParlors={closestParlors}
        nearbyFacilities={nearbyFacilities}
      />
      <PrepaidBanners
        isMobile
        title="장례 비용을 줄이시고 싶으시다면"
        extra="(장례식장 비용이 아닌 인력, 용품, 차량 패키지에 대해 적용)"
        eventPath="parlor_detail"
      />
      <Box padding="6px 16px">
        <SelectedReviews
          title={<>후기 평균 4.9점, 진짜 고객이 말합니다.</>}
          path="parlor_detail"
          headingAs="h2"
        />
      </Box>
      <Spacing gap={120} />
    </>
  );
}

export default TabInfoSectionVersion;
